



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_invoiceOverdueNoticeFragments } from '@/queries/__generated__/invoiceOverdueNoticeFragments';
import { GQL_invoice_invoice } from '@/queries/__generated__/invoice';
import { GQL_emailInvoiceOverdueNotice } from '@/queries/__generated__/emailInvoiceOverdueNotice';
import MailButton from '../../Shared/MailButton.vue';
import i18n from '@/i18n';
import { emailRecipients } from '@/app/Invoice';
import gql from 'graphql-tag';

 const INVOICE_OVERDUE_NOTICE_MAIL = gql`
  mutation emailInvoiceOverdueNotice($invoiceOverdueNoticeId: ID!, $recipients: [String!]!) {
    emailInvoiceOverdueNotice(
      input: {
        invoiceOverdueNoticeId: $invoiceOverdueNoticeId,
        recipients: $recipients,
      }
    ) {
      logInvoiceOverdueNoticeMail {
        id
        sentAt
        sentBy {
          id
          name
        }
        recipientMail
        deliveryStatus
        deliveryError
      }
    }
  },
`;

@Component ({
  components: {
    MailButton,
  },
})
export default class InvoiceOverdueNoticeMailButton extends Vue {
  @Prop() private invoice!: GQL_invoice_invoice;
  @Prop() private invoiceOverdueNotice!: GQL_invoiceOverdueNoticeFragments;
  @Prop({ type: Boolean, default: false }) addCompanyMailToCC!: boolean;

  private INVOICE_OVERDUE_NOTICE_MAIL = INVOICE_OVERDUE_NOTICE_MAIL;

  private recipient: string | null = "";
  private copies: string[] = [];

  private mounted() {
    this.resetRecipients();
  }

  private resetRecipients() {
    [ this.recipient, this.copies ] = emailRecipients(
      this.invoice.customer.email || false,
      this.addCompanyMailToCC,
      this.invoice.supplierParty.email || false,
    );
  }

  private onSent(data: GQL_emailInvoiceOverdueNotice) {
    this.$sMessage.success(i18n.t('Document.Email.sendSuccess'));
    this.resetRecipients();
    this.$emit('sent', data);
  }

  // Lets the caller open the mail dialog without a click, e.g. right after the
  // reminder has been written.
  public open() {
    (this.$refs.mailButton as MailButton).open();
  }
}
